import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditSelectable } from '../../formControls/edit-select-form-control.component';
import { LoadingService } from '../../shared/services/loading.service';
import { PaymentsService } from '../../shared/services/payment/payment.service';
import { TenantsService } from '../../shared/services/tenants/tenants.service';
import { UsersService } from '../../shared/services/users/users.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';
@Component({
  selector: 'app-user-preferred-language-dialog',
  templateUrl: './user-preferred-language-dialog.component.html',
  styleUrls: ['./user-preferred-language-dialog.component.scss']
})
export class UserPreferredLanguageDialogComponent
  implements EditDialogInstance {

  userPreferredLanguageForm: FormGroup;
  languageOptions: EditSelectable[] = [
    { name: 'Deutsch', id: 'de' },
    { name: 'English', id: 'en' }
  ];
  currentUsersPreferredLanguage: string;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public userService: UsersService,
    public loadingService: LoadingService,
    public tenantService: TenantsService,
    public paymentsService: PaymentsService,
    public userSerivce: UsersService
  ) {

    // check the current users licence state
    this.currentUsersPreferredLanguage = this.userSerivce.getCurrentUsersPreferredlanguage();

    // build the form
    this.userPreferredLanguageForm = new FormGroup({});
    // add form controls
    this.userPreferredLanguageForm.addControl('preferredLanguage', new FormControl(this.currentUsersPreferredLanguage, undefined));
  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(this.userPreferredLanguageForm.value);
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.userPreferredLanguageForm;
  }

}
